import axios from "axios";
import { Cookies } from "../utils/cookies";

const loginUrl = "https://api.vole.io/auth/login";
const apiUrl = "https://api.vole.io";
const vodUrl = "https://vod-api.vole.io/feed";
const vodDetailUrl = "https://vod-api.vole.io/video";
const interactionUrl = "https://api.vole.io/interactions-api/v1/interactables";

const loginApiCall = async (username, password) => {
  return await axios.post(`${loginUrl}`, {
    username: username,
    password: password,
    timestamp: 1467019594,
    hash: "fffaf39e488a1cc601f265feaaa6c63a4217244a",
    deviceToken: "", //bildirim için
    deviceInfo: {
      os: "Chrome",
      resolution: "1920x1080"
    }
  });
};

const getFeedUserBased = async () => {
  return await axios.get(`${vodUrl}/userBased`, {
    headers: {
      "X-Auth-Token": Cookies.get("token")
    }
  });
};

const getFeedLanding = async () => {
  return await axios.get(`${vodUrl}/landing`, {
    headers: {
      "X-Auth-Token": Cookies.get("token")
    }
  });
};

const getVodList = async (id, reference = null) => {
  return await axios.get(`${vodUrl}/showcase/${id}`, {
    headers: {
      "X-Auth-Token": Cookies.get("token")
    },
    params: { references: reference }
  });
};

const getVodDetailApi = async (id) => {
  return await axios.get(`${vodDetailUrl}/${id}`, {
    headers: {
      "X-Auth-Token": Cookies.get("token")
    }
  });
};

const getFeedRelatedApi = async (token = "") => {
  if (!token) {
    token = Cookies.get("token");
  }
  return await axios.get(`${vodUrl}/related`, {
    headers: {
      "X-Auth-Token": token
    }
  });
};

const getVideoComments = async (iKey) => {
  return await axios.get(`${interactionUrl}/${iKey}/comments`, {
    headers: {
      "X-Auth-Token": Cookies.get("token")
    }
  });
};

const postVideoComment = async (iKey, comment) => {
  return await axios.post(
    `${interactionUrl}/${iKey}/comments`,
    { comment: comment },
    {
      headers: {
        "X-Auth-Token": Cookies.get("token")
      }
    }
  );
};

const deleteVideoComment = async (id) => {
  return await axios.delete(
    `https://api.vole.io/interactions-api/v1/comments/${id}`,
    {
      headers: {
        "X-Auth-Token": Cookies.get("token")
      }
    }
  );
};

const postViewInteraction = async (iKey) => {
  return await axios.post(`${interactionUrl}/${iKey}/view`, null, {
    headers: {
      "X-Auth-Token": Cookies.get("token")
    }
  });
};

const postClickInteraction = async (iKey) => {
  return await axios.post(`${interactionUrl}/${iKey}/click`, null, {
    headers: {
      "X-Auth-Token": Cookies.get("token")
    }
  });
};

const getCurrentUserApiCall = async (token = "") => {
  if (!token) {
    token = Cookies.get("token");
  }
  return await axios.get(`${apiUrl}/me/profile`, {
    headers: {
      "X-Auth-Token": token
    }
  });
};

const getInteractionsApiCall = async (iKey) => {
  return await axios.get(`${interactionUrl}/${iKey}/info`, {
    headers: {
      "X-Auth-Token": Cookies.get("token")
    }
  });
};

const likeApicall = async (iKey) => {
  return await axios.post(`${interactionUrl}/${iKey}/like`, null, {
    headers: {
      "X-Auth-Token": Cookies.get("token")
    }
  });
};

const unLikeApiCall = async (iKey) => {
  return await axios.post(`${interactionUrl}/${iKey}/unlike`, null, {
    headers: {
      "X-Auth-Token": Cookies.get("token")
    }
  });
};

export {
  getFeedUserBased,
  getFeedLanding,
  loginApiCall,
  getVodList,
  getVodDetailApi,
  getFeedRelatedApi,
  getVideoComments,
  postVideoComment,
  postViewInteraction,
  postClickInteraction,
  getCurrentUserApiCall,
  getInteractionsApiCall,
  likeApicall,
  unLikeApiCall,
  deleteVideoComment
};
